import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  FormFieldTypes,
  LoadingStatus,
  ToastThemes,
} from '../../../../../constants/common';
import { showToast } from '../../../../../utils/common.util';
import TryAgain from '../../../../molecules/ErrorState/error.component';
import CircularLoader from '../../../../../atoms/CircularLoader/circular-loader';
import PaycycleFormEdit from './org-config-form/org-config-form-edit';
import PaycycleFormView from './org-config-form/org-config-form-view';
import { FormServices } from '../../../../../services/formConfig';

const AddSalaryComponent = (props) => {
  const {
    viewMode,
    setViewMode,
    payCycleId,
    setShowForm,
    setPayCycleId,
    moduleId,
  } = props;
  const { currentUserRoleId } = useSelector((state) => state.main);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(-1);
  const [config, setConfig] = useState([]);

  useEffect(async () => {
    if (currentUserRoleId) {
      if (payCycleId) {
        setLoading(LoadingStatus.Loading);
        await new FormServices()
          .getOrgConfigDetail(payCycleId)
          .then((res) => {
            setFormData(res);
            setLoading(LoadingStatus.Success);
            setViewMode(true);
          })
          .catch((err) => {
            showToast(err?.response?.data?.message, ToastThemes.error);
            setLoading(LoadingStatus.Failure);
            throw err?.response?.data?.message;
          });
      }
    }
    return () => {
      setViewMode(false);
    };
  }, [payCycleId, currentUserRoleId]);

  useEffect(() => {
    setConfig([
      {
        id: 1,
        fieldLabel: 'Config ID',
        placeholderText: 'Type Here',
        fieldType: FormFieldTypes.Text,
        isRequired: true,
        isHidden: false,
        fieldRefName: 'var_name',
        size: 'small',
        fullWidth: true,
        fieldSize: 6,
        toUpperCase: true,
        onKeyDown: preventKeyPress,
        tooltipText: 'Only letters, numbers, and underscores are allowed.',
        isReadOnly: viewMode,
      },
      {
        id: 1,
        fieldLabel: 'Data Type',
        placeholderText: 'Select Option',
        fieldType: FormFieldTypes.SingleSelect,
        isRequired: false,
        isHidden: false,
        fieldRefName: 'value_data_type',
        size: 'small',
        fullWidth: true,
        fieldSize: 6,
      },
      {
        id: 1,
        fieldLabel: 'Value',
        placeholderText: 'Type Here',
        fieldType: FormFieldTypes.Text,
        isRequired: false,
        isHidden: false,
        fieldRefName: 'var_value',
        size: 'small',
        fullWidth: true,
      },
      {
        fieldLabel: 'Is Editable?',
        fieldType: FormFieldTypes.CheckBox,
        isRequired: false,
        fieldRefName: 'isEditable',
        isReadOnly: viewMode,
        fieldSize: 6,
      },
      {
        fieldLabel: 'Description',
        fieldType: FormFieldTypes.Text,
        dataType: FormFieldTypes.MultiLineText,
        isRequired: false,
        fieldRefName: 'description',
        isReadOnly: viewMode,
        fieldSize: 12,
      },
    ]);
  }, [formData]);

  if (loading === LoadingStatus.Failure) {
    return <TryAgain />;
  }
  return (
    <>
      <CircularLoader show={loading === LoadingStatus.Loading && payCycleId} />
      {loading === LoadingStatus.Success && viewMode ? (
        <PaycycleFormView
          formConfig={config}
          setViewMode={setViewMode}
          isNew={!payCycleId}
          formData={formData}
          setShowForm={setShowForm}
          isEditable={formData?.isEditable || false}
        />
      ) : (
        <PaycycleFormEdit
          formConfig={config}
          setViewMode={setViewMode}
          formData={formData}
          isNew={!payCycleId}
          setShowForm={setShowForm}
          payCycleId={payCycleId}
          setPayCycleId={setPayCycleId}
          moduleId={moduleId}
        />
      )}
    </>
  );
};

export default AddSalaryComponent;

function preventKeyPress(e) {
  const key = e.key;
  const allowed =
    /^[a-zA-Z0-9_]$/.test(key) || // letters, numbers, underscore
    [
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Backspace',
      'Delete',
      'Tab',
      'Shift',
      'Alt',
      'Control',
      'Meta',
    ].includes(key);

  if (!allowed) {
    e.preventDefault();
  }
}
